import { useStoreon } from "storeon/react";

const getOption = (options, name) => options.find((opt) => opt.code === name);

const getParentRadioOption = (options, name) =>
  options.find((opt) => opt.parent_code === name && opt.type_code === "radio");

export const useProboSize = () => {
  const { productOptions: options } = useStoreon("productOptions");

  const width = getOption(options, "width")?.value;
  const height = getOption(options, "height")?.value;

  const size = getParentRadioOption(options, "size")?.code;
  const paperFormat = getParentRadioOption(options, "finishing-size")
    ?.description;

  const proboSize = {
    width: null,
    height: null,
    lockedWidth: false,
    lockedHeight: false,
  };

  if (size) {
    const [formatWidth, formatHeight] = size
      .split("x")
      .map((val) => parseInt(val, 10));

    if (formatWidth && formatHeight) {
      proboSize.width = formatWidth;
      proboSize.height = formatHeight;
      return {
        width: formatWidth,
        height: formatHeight,
        lockedWidth: true,
        lockedHeight: true,
      };
    }
    if (height && formatWidth) {
      return {
        width: formatWidth,
        height,
        lockedWidth: true,
        lockedHeight: false,
      };
    }
  }

  if (width && height) {
    return {
      width,
      height,
      lockedWidth: false,
      lockedHeight: false,
    };
  }

  if (paperFormat) {
    const [formatWidth, formatHeight] = paperFormat
      .split("x")
      .map((val) => parseFloat(val, 10));
    if (formatWidth && formatHeight) {
      return {
        width: formatHeight,
        height: formatWidth,
        lockedWidth: true,
        lockedHeight: true,
      };
    }
  }

  return proboSize;
};

export const getProboSizeRange = (options) => {
  const width = getOption(options, "width");
  const height = getOption(options, "height");

  const wMin = parseFloat(width?.min_value, 10);
  const wMax = parseFloat(width?.max_value, 10);
  const hMin = parseFloat(height?.min_value, 10);
  const hMax = parseFloat(height?.max_value, 10);

  return {
    ...(width && {
      width: {
        min: isNaN(wMin) ? 0 : wMin,
        max: isNaN(wMax) ? 0 : wMax,
      },
    }),
    ...(height && {
      height: {
        min: isNaN(hMin) ? 0 : hMin,
        max: isNaN(hMax) ? 0 : hMax,
      },
    }),
  };
};

export const useProboSizeRange = () => {
  const { productOptions: options } = useStoreon("productOptions");
  return getProboSizeRange(options);
};

export const getProboAmount = (options) => {
  const proboAmount = parseInt(
    options.find((opt) => opt.code === "amount")?.value,
    10
  );
  return Number.isNaN(proboAmount) ? "1" : proboAmount;
};

export const useProboAmount = () => {
  const { productOptions } = useStoreon("productOptions");
  return getProboAmount(productOptions);
};
